module.exports = __webpack_public_path__ + "static/img/logo.702573ff.png";